
import { Box } from '@mui/material';

export default function PyramidLevel({ index, imgUrl, imgUrlWithColor, setCurrentLevel, level }) {
  const isActive = level === index;
  const isBelow = level < index;
  const isAbove = level > index;

  return (
      <Box
        sx={{
          position: 'absolute',
          zIndex: 10 - index,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
          cursor: 'pointer',
          transition: 'transform 500ms cubic-bezier(0.25, 0.57, 0.33, 0.99)',
          WebkitTapHighlightColor: 'transparent',
          transform: isBelow 
            ? 'translateY(25px)' 
            : isAbove 
              ? 'translateY(-25px)' 
              : 'translateY(0)',
          opacity: isAbove ? 0.4 : 1,
          top: `calc(50px + ${index * 36}px)`,
          height: `${72 + index * 12}px`,
        }}
      >
        <Box
          component="picture"
          sx={{
            position: 'absolute',
            maxWidth: '480px',
            width: '100%',
            '& img': {
              display: 'block',
              width: '100%',
              height: 'auto',
              filter: 'drop-shadow(0 0 6px rgba(0, 122, 255, 0.3))',
              transform: `translateY(-${6 + index}px)`,
            },
          }}
        >
          <source srcSet={imgUrl[1]} />
          <img src={imgUrl[0]} alt='Transparent layer' loading='lazy' />
        </Box>

        <Box
          component="picture"
          className={`color-img ${isActive ? 'selected' : ''}`}
          sx={{
            position: 'absolute',
            maxWidth: '480px',
            width: '100%',
            opacity: isActive ? 1 : 0,
            transition: 'opacity 500ms ease-in',
            '& img': {
              display: 'block',
              width: '100%',
              height: 'auto',
              filter: 'drop-shadow(0 0 10px rgba(0, 122, 255, 0.4))',
              transform: `translateY(-${6 + index}px)`,
            },
          }}
        >
          <source srcSet={imgUrlWithColor[1]} />
          <img
              src={imgUrlWithColor[0]}
              alt='Colored layer'
              loading='lazy'
              onMouseOver={() => {
                setCurrentLevel(index);
              }}
          />
        </Box>
      </Box>
  );
};
